export function waitForElementToExist (selector) {
  return new Promise((resolve) => {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          const wgForm = document.querySelector(selector)
          if (wgForm !== null) {
            observer.disconnect()
            resolve(wgForm)
          }
        }
      })
    })

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    })
  })
}